// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.5.232",
  "gitHash": "69112183d442aa2713c43677b0aed8708a1fe894",
  "versionWithHash": "5.5.232-69112183d442aa2713c43677b0aed8708a1fe894"
};
